import {Injectable} from '@angular/core';

/**
 * Switcher de temas en runtime. Migrado de `require('*.scss')` + inyección de CSS
 * (que Angular 14+ / webpack 5 ya no soporta) a lazy style bundles: cada tema se
 * compila a `theme-x.css` (angular.json styles con inject:false) y se activa
 * intercambiando el href de un <link>.
 */
@Injectable()
export class ThemesService {

  private linkTag: HTMLLinkElement;
  defaultTheme = 'A';

  constructor() {
    this.createLink();
    this.setTheme(this.defaultTheme);
  }

  private createLink() {
    const head = document.head || document.getElementsByTagName('head')[0];
    this.linkTag = document.createElement('link');
    this.linkTag.rel = 'stylesheet';
    this.linkTag.id = 'appthemes';
    head.appendChild(this.linkTag);
  }

  setTheme(name) {
    this.linkTag.href = 'theme-' + String(name).toLowerCase() + '.css';
  }

  getDefaultTheme() {
    return this.defaultTheme;
  }

}
